<app-loader-icon [darkMode]="whiteColor"></app-loader-icon>

<p>{{ message || defaultMessage }}</p>
